"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RailwayAPI = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RailwayAPI = /*#__PURE__*/function () {
  function RailwayAPI(_ref) {
    var customerKey = _ref.customerKey,
        userSetting = _ref.userSetting,
        lfToken = _ref.lfToken,
        lfCustKey = _ref.lfCustKey,
        lfAPIToken = _ref.lfAPIToken;
    (0, _classCallCheck2.default)(this, RailwayAPI);
    this.customerKey = null;
    this.settings = {};
    this.lfToken = null;
    this.lfCustKey = null;
    this.lfAPIToken = null;
    this.requestAuth = null;
    this.requestParameters = null;
    this.helper = new _helper.Helper();
    this.customerKey = customerKey;
    this.settings = userSetting;
    this.lfToken = lfToken;
    this.lfCustKey = lfCustKey;
    this.lfAPIToken = lfAPIToken;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.customerKey);
  }

  (0, _createClass2.default)(RailwayAPI, [{
    key: "getPlan",
    value: function getPlan(payload) {
      return this.requestAuth.get('AI_ORDER_PLANNING_ALL', '', _objectSpread(_objectSpread({}, this.requestParameters), payload));
    }
  }, {
    key: "insertPlan",
    value: function insertPlan(payload) {
      return this.requestAuth.post('AI_ORDER_PLANNING_ALL', '', this.requestParameters, payload);
    }
  }, {
    key: "updatePlan",
    value: function updatePlan(payload) {
      return this.requestAuth.put('AI_ORDER_PLANNING_ALL', '', this.requestParameters, payload);
    }
  }, {
    key: "deleteRoutes",
    value: function deleteRoutes(payload) {
      return this.requestAuth.delete('AI_ORDER_PLANNING_ALL', '', this.requestParameters, payload);
    }
  }, {
    key: "deleteRoute",
    value: function deleteRoute(_ref2) {
      var id = _ref2.id;
      return this.requestAuth.delete('AI_ORDER_PLANNING', id, this.requestParameters);
    }
  }, {
    key: "getOrdersInPlan",
    value: function getOrdersInPlan(payload) {
      var requestAuth = new _request.Request('application/json', this.lfToken);
      var hook3 = this.helper.get(this.settings, 'hook3', '');

      if (!this.helper.isUndefined(hook3)) {
        return this.requestAuth.get(hook3, '', {}, true);
      }

      return requestAuth.put('LEGACY_CORE_V3', 'routeplanning/order?formatted=true&modeType=railway', {}, payload);
    }
  }, {
    key: "updateOrdersInPlan",
    value: function updateOrdersInPlan(payload) {
      var requestAuth = new _request.Request('application/json', this.lfToken);
      payload['type'] = 'planning-tools-railway';
      return requestAuth.put('LEGACY_CORE_V3', 'routeplanning/planningcode', {}, payload);
    }
  }, {
    key: "getGpsData",
    value: function getGpsData(payload) {
      var requestAuth = new _request.Request('application/json', this.lfToken);
      return requestAuth.get('LEGACY_CORE', 'thitgpsrecs', _objectSpread({
        'convertToString': 'true',
        'limit': 1,
        'order': 'PosAt:DESC'
      }, payload));
    }
  }]);
  return RailwayAPI;
}();

exports.RailwayAPI = RailwayAPI;